import React from 'react';
import PropTypes from 'prop-types';

import CommentModal from '~/src/components/comment/commentModal/CommentModal';
import Modal from '~/src/components/modal/Modal';

import initPolyglot from '~/src/utilities/libs/polyglot';
import {escalateComment} from '~/src/utilities/feed/comment';
import {classNames} from '~/src/utilities/helpers/css';
import {withSettingsContext} from '~/src/components/context/SettingsContext';
import {withUserProfileContext} from '~/src/components/context/UserProfileContext';

import css from './CommentEscalation.module.scss';
import i18nStrings from './CommentEscalation.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class CommentEscalation extends React.Component {
    hideMessage = () => {
        this.setState({message: null});
    };

    showMessage = (message) => {
        this.setState({message});
    };

    cancelEscalation = () => {
        this.setState({
            escalationText: '',
            nicknameValue: this.props.context.userProfile?.nickname || '',
            sendButtonActive: false,
            inputFieldOpen: false
        });
    };

    handleEscalateComment = async () => {
        if (this.state.sendButtonActive) {
            try {
                await escalateComment(this.props.id, this.state.escalationText);
                this.showMessage(getTranslation('escalationSendSuccessful'));
                this.cancelEscalation();
            } catch (err) {
                this.showMessage(getTranslation('escalationSendFailed'));
            }
        }
    };

    escalationTextValid = (escalationText) => {
        return escalationText && escalationText.length >= 2;
    };

    handleNicknameValueChange = (event) => {
        this.setState({
            nicknameValue: event.target.value,
            sendButtonActive: event.target.value && this.escalationTextValid(this.state.escalationText)
        });
    };

    handleEscalationTextChange = (event) => {
        this.setState({
            escalationText: event.target.value,
            sendButtonActive: this.escalationTextValid(event.target.value) && this.state.nicknameValue
        });
    };

    toggleCommentEscalation = () => {
        this.setState({
            inputFieldOpen: !this.state.inputFieldOpen
        });
    };

    constructor(props) {
        super(props);

        this.state = {
            sendButtonActive: false,
            nicknameValue: props.context.userProfile?.nickname || '',
            escalationText: '',
            inputFieldOpen: props.inputFieldOpen,
            message: null
        };
    }

    render() {
        const {settings, userProfile} = this.props.context;
        const sendButtonActive = this.state.sendButtonActive;
        const sendButton = classNames(css, 'sendButton', {sendButtonActive});
        const inputClassNames = classNames(css, 'commentEscalation', settings.siteArea);
        const toggleButtonClassNames = classNames(css, 'toggleButtonCommentEscalation', settings.siteArea);

        return (
            <>
                <button className={toggleButtonClassNames} onClick={this.toggleCommentEscalation} data-testid="EscalationToggle">
                    {getTranslation('escalateComment')}
                </button>

                {this.state.inputFieldOpen && (
                    <div className={inputClassNames} data-testid="EscalationForm">
                        <label className={css.textContainer}>
                            {getTranslation('escalationText')}
                            <textarea
                                type="text"
                                value={this.state.escalationText}
                                onChange={this.handleEscalationTextChange}
                                data-testid="EscalationText"
                            ></textarea>
                        </label>

                        <label className={css.nicknameContainer}>
                            {getTranslation('nickname')}
                            <input
                                type="text"
                                value={userProfile?.nickname || this.state.nicknameValue}
                                onChange={this.handleNicknameValueChange}
                                disabled={userProfile?.nickname}
                            />
                        </label>

                        <div className={css.buttonContainer}>
                            <div className={css.cancelButton} onClick={this.cancelEscalation} data-testid="EscalationCancelButton">
                                {getTranslation('cancel')}
                            </div>
                            <div className={sendButton} onClick={this.handleEscalateComment} data-testid="EscalationSendButton">
                                <span>{getTranslation('send')}</span>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.message && (
                    <Modal>
                        <CommentModal onClose={this.hideMessage} message={this.state.message} />
                    </Modal>
                )}
            </>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    CommentEscalation.propTypes = {
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    };
}

export default withSettingsContext(withUserProfileContext(CommentEscalation));
